interface IGetOwnValueProps<TValue> {
  record: Readonly<Record<string, TValue>>;
  key: string;
}

// NOTE: NSAI-5414 — the own-property lookup for a plain-object table keyed by a
// string the client does not control: an attachment's MIME type, the extension
// of a file name, a tool name or a tool argument the model produced. A bare
// `TABLE[key]` walks the prototype chain, so `"toString"`, `"constructor"`,
// `"hasOwnProperty"` or `"__proto__"` resolves to an `Object.prototype` member —
// truthy, so a `??` / `||` fallback never applies, and the caller then renders a
// function or an object where it expected a string or a component. Only an own
// entry counts; anything else reads as a miss and takes the caller's fallback.
export const getOwnValue = <TValue>({
  record,
  key,
}: IGetOwnValueProps<TValue>): TValue | undefined =>
  Object.hasOwn(record, key) ? record[key] : undefined;
